// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "edm-desenv.firebaseapp.com",
  "projectId": "edm-desenv",
  "storageBucket": "edm-desenv.firebasestorage.app",
  "messagingSenderId": "20258923490",
  "appId": "1:20258923490:web:402d98a2360c7f0a770fbb",
  "measurementId": "G-9W56S9TPXB",
  "apiKey": "AIzaSyBuJbFdlJCLg3VYUQJHb_wFxvB_-R0NUOU"
};
